import { render, staticRenderFns } from "./examineeDetail.vue?vue&type=template&id=cc067e84&scoped=true&"
import script from "./examineeDetail.vue?vue&type=script&lang=js&"
export * from "./examineeDetail.vue?vue&type=script&lang=js&"
import style0 from "./examineeDetail.vue?vue&type=style&index=0&id=cc067e84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc067e84",
  null
  
)

export default component.exports